/**
 * Resolves the position (index) of the feedback survey, given how many solutions are displayed.
 *
 * @param {number} filteredStudentSolutionsCount
 * @return {number}
 */
export const resolvePosition = (filteredStudentSolutionsCount: number): number => {
  if (filteredStudentSolutionsCount > 5) {
    return Math.ceil(filteredStudentSolutionsCount / 100 * 80);
  } else {
    return filteredStudentSolutionsCount - 1;
  }
};

/**
 * Resolves whether the grade should be updated.
 *
 * Helps avoid sending analytics events and DOM updates when the grade hasn't really changed.
 *
 * @param previousSessionGrade
 * @param currentSessionGrade
 * @param newlySelectedGrade
 */
export const shouldUpdateGrade = (previousSessionGrade: number | null, currentSessionGrade: number | null, newlySelectedGrade: number): boolean => {
  let isDifferentGrade = false;

  if (newlySelectedGrade) {
    if (!currentSessionGrade) {
      if (!previousSessionGrade) {
        // When there was no previously selected grade (from previous session) and no grade has been selected yet, then update it
        isDifferentGrade = true;
      } else {
        if (previousSessionGrade !== newlySelectedGrade) {
          // When there was a grade previously selected (from previous session) and the newly selected grade is different, then update it
          isDifferentGrade = true;
        }
      }
    } else {
      // When there was a grade previously selected (from current session), then we don't care about whether a grade was previously selected (from previous session)
      // If the selected grade is different that the previously selected grade (from current session), then update it
      if (currentSessionGrade !== newlySelectedGrade) {
        isDifferentGrade = true;
      }
    }
  }

  return isDifferentGrade;
};
